



































import { Component, Prop, Vue } from "vue-property-decorator";
import StandartModal from "@/components/app/standart-modal.vue";

export interface IFaqStep {
  icon: string;
  text: string;
}

@Component({ components: { StandartModal } })
export default class StandartFaq extends Vue {
  @Prop({ type: String, default: "standart-faq" }) modalId!: string;
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: String, default: "F.A.Q" }) button!: string;
  @Prop({ type: Array, default: () => [] }) steps!: Array<IFaqStep>;
}
